const light = Object.freeze({
    primary: '#0090DF',
    secondary: '#FFD400',
    navBackground: '#FFFFFF',
    tileBackground: '#FFFFFF',
    appBackground: '#F5F5F5',
    inputBackground: '#FFFFFF',
    logoColor: '#0090DF',
    logoFontColor: '#003C79',
    error: '#D9000D',
    info: '#0090DF',
    success: '#4CAF50',
    warning: '#FB8C00',
})

const dark = Object.freeze({
    primary: '#99D2F2',
    secondary: '#FFED99',
    navBackground: '#2C2C2C',
    tileBackground: '#2C2C2C',
    appBackground: '#1B1B1B',
    inputBackground: '#222222',
    logoColor: '#0090DF',
    logoFontColor: '#003C79',
    error: '#EF999E',
    info: '#99D2F2',
    success: '#B7DFB9',
    warning: '#FDD199',
})

const props = Object.freeze({
    headerLogoWidth: 150,
    headerLogoSrc: require('@/assets/custom/images/headers/living-header.jpg')
})

module.exports = Object.freeze({
    light,
    dark,
    props
})